"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1130],{

/***/ 11130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34427);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74237);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41464);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92021);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96528);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83910);








var BaseContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83980));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83980)
            ];
        }
    }
});
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        wrapperCoverStore: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            maxHeight: "25.2rem",
            height: "25.2rem",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            background: "linear-gradient(111.02deg, ".concat(theme.palette.primary[900], " 12.25%, ").concat(theme.palette.primary[800], " 100.52%, ").concat(theme.palette.primary[800], " 100.52%)")
        }, theme.breakpoints.between("xs", "sm"), {
            minHeight: "19.9rem",
            maxHeight: "19.9rem"
        }),
        coverStoreTitle: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            marginTop: ""
        }, theme.breakpoints.between("xs", "sm"), {
            margin: "4.8rem 0 0.8rem 0"
        }),
        coverStoreSubTitle: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.breakpoints.between("xs", "sm"), {
            margin: "0 0 4.8rem 0"
        })
    };
});
var CoverCommon = function(props) {
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var classes = useStyles();
    var isMobile = (0,hooks_useCustomMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: classes.wrapperCoverStore
    }, props.bg && {
        background: props.bg
    }), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
            container: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BaseContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    xs: 12,
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignContent: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                textAlign: "center",
                                fontWeight: 700,
                                variant: isMobile ? "h4" : "h3",
                                lineHeight: "5rem",
                                className: classes.coverStoreTitle,
                                children: props.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                textAlign: "center",
                                lineHeight: "2.2rem",
                                fontWeight: 500,
                                variant: isMobile ? "subtitle2" : "subtitle1",
                                color: theme.palette.text.disabled,
                                className: classes.coverStoreSubTitle,
                                children: props.subTitle
                            })
                        ]
                    })
                })
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (CoverCommon);


/***/ })

}]);